const normalizeDate = (date) => {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

export const compareDate = (dateString, condition=">", today= new Date())=>{
    if(typeof today === 'string') today = new Date(today)
    let specificDate = normalizeDate(new Date(dateString));
    const normalizedToday = normalizeDate(today);
    if (condition == '<'&& (specificDate < normalizedToday))  return true;
    if (condition == '>' && (specificDate > normalizedToday))  return true;
    if (condition == '=' && (normalizedSpecificDate == normalizedToday) ) return true;
    return false;
}